/* The scenes remain readable without JavaScript. No autoplay: visitors choose the frame. */
(() => {
 class SPLookbook extends HTMLElement {
  connectedCallback(){
   if(this.controller)return;
   this.scenes=Array.from(this.querySelectorAll('[data-sp-scene]'));this.controls=this.querySelector('[data-sp-scene-controls]');this.status=this.querySelector('[data-sp-scene-status]');
   if(!this.scenes.length||!this.controls)return;
   this.controller=new AbortController();const options={signal:this.controller.signal};
   this.buttons=this.scenes.map((scene,index)=>{
    const button=document.createElement('button');button.type='button';button.textContent=scene.dataset.label||scene.querySelector('h3')?.textContent||'Escena';button.dataset.spSceneButton=String(index);button.setAttribute('aria-controls',scene.id);
    button.addEventListener('click',()=>this.select(index,true),options);
    button.addEventListener('keydown',event=>{
     let next=index;
     if(event.key==='ArrowRight')next=(index+1)%this.scenes.length;
     else if(event.key==='ArrowLeft')next=(index-1+this.scenes.length)%this.scenes.length;
     else if(event.key==='Home')next=0;
     else if(event.key==='End')next=this.scenes.length-1;
     else return;
     event.preventDefault();this.select(next,true);this.buttons[next].focus({preventScroll:true});
    },options);return button;
   });
   this.controls.replaceChildren(...this.buttons);this.controls.hidden=this.scenes.length<2;this.select(0,false);
   this.querySelector('.sp-lookbook__scenes').addEventListener('pointerdown',event=>{
    if(event.pointerType!=='touch'||event.target.closest('button,a,input'))return;
    this.touch={x:event.clientX,y:event.clientY,id:event.pointerId};
   },options);
   this.addEventListener('pointerup',event=>{
    const touch=this.touch;this.touch=null;if(!touch||touch.id!==event.pointerId)return;
    const dx=event.clientX-touch.x,dy=event.clientY-touch.y;
    if(Math.abs(dx)<60||Math.abs(dy)>60||Math.abs(dx)<Math.abs(dy)*1.5)return;
    this.select((this.index+(dx<0?1:-1)+this.scenes.length)%this.scenes.length,true);
   },options);
   this.addEventListener('pointercancel',()=>{this.touch=null;},options);
   document.addEventListener('shopify:block:select',event=>{
    const index=this.scenes.findIndex(scene=>scene===event.target||scene.contains(event.target)||scene.dataset.blockId===event.detail?.blockId);
    if(index>=0)this.select(index,false);
   },options);
  }
  select(index,animate){
   if(!this.scenes[index])return;
   const changed=this.index!==index;this.index=index;
   this.scenes.forEach((scene,i)=>{scene.hidden=i!==index;this.buttons[i].setAttribute('aria-pressed',String(i===index));});
   if(changed&&animate){this.status.textContent=this.scenes[index].dataset.label;if(typeof spAnimate==='function')spAnimate(this.scenes[index],[{opacity:.35,transform:'translateY(5px)'},{opacity:1,transform:'translateY(0)'}],240);}
  }
  disconnectedCallback(){this.controller?.abort();this.controller=null;this.touch=null;}
 }
 if(!customElements.get('sp-lookbook'))customElements.define('sp-lookbook',SPLookbook);
})();
